<template>
  <div v-if="testtextbool" class="cat-test" >
              {{showtel}}
  </div>
</template>
 
<script>
export default {
  name: "CatInput",
  props: {
    time:60,
    showtel:{
    type: String,
    default: "",
    },
    testtextbool:{
 type: Boolean,
   default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    rtest:{
 type: String,
     default: "",
    },
    name: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordVisiable: false, //控制是否显示密码
    };
  },
  methods: {
    //  handleinput(event) {
    //   //父组件在绑定v-model时，其实就绑定的input事件，因此父组件不需要再声明事件了
    //   if((event.target.value).trim().length!=11||Number(event.target.value)=='NaN'){
    //     this.$emit(`update:testtextbool`, true)
    //   }else{
    //      this.$emit(`update:testtextbool`, false)
    //   }
    //   this.$emit("input", event.target.value);
    //   console.log('suru')
    // },
  },
 
};
</script>
<style lang="less" scoped>
 .cat-test{
    color: red;
    font-size: 28px;
    // height: @minboxgao;
    // line-height: @minboxgao;
    // padding-left: @padingbox;
     padding-top: @padingbox;
 }



</style>